import React from 'react'
import ReactSelect from 'react-select'

var interval = 0;

const onSearch = (search) => {
  if(interval) clearTimeout(interval);
   interval = setTimeout(() => {
     search();
   }, 1000)
}

const ReactSelectTalentSearch = ({field, validate, search, isFixed,clear}) => {
  let hasErrors = field.errors.length > 0 ? true : false

  let options = field.filteredOptions ? field.filteredOptions : field.options;
  
  if(clear){
    field.value = false;
  }

  return (
    <div className={hasErrors ? 'form-group text-danger' : 'form-group'}>
      <label className="col-form-label col-form-label-sm">{field.rules.title}</label>

      <ReactSelect
        multi={false}
        placeholder={field.placeholder}
        autosize={false}
        autoFocus
        options={options}
        simpleValue
        clearable={isFixed == true ? false:true}
        name={field.name}
        disabled={isFixed == true ? true:false}
        value={field.value}
        isFixed
        onChange={
          value => {
            validate(value, field);
            onSearch(search);
          }
        }
        searchable={true}
      />
      {field.errors.map((error, i) => (
        <div key={i} className="form-text text-danger">
          {error}
        </div>
      ))}
    </div>
  )
}

export default (ReactSelectTalentSearch)
